import * as React from 'react';
import { Result } from 'antd';
import './ForbiddenPage.scss';
import { FrontLayout } from 'client/ui/layout/FrontLayout';

export interface IForbiddenPageProps {}

export function ForbiddenPage(props: IForbiddenPageProps) {
  return (
    <FrontLayout>
      <Result
        status="error"
        title="Non Autorizzato"
        subTitle="Non si dispone dei permessi per visualizzare la pagina richiesta."
      />
    </FrontLayout>
  );
}
